import { render, staticRenderFns } from "./PostFormImmoSurfaceMainTab.vue?vue&type=template&id=66d3ad6c&scoped=true&"
import script from "./PostFormImmoSurfaceMainTab.vue?vue&type=script&lang=js&"
export * from "./PostFormImmoSurfaceMainTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3ad6c",
  null
  
)

export default component.exports